import raf from 'raf';
import React, { Component } from 'react';

const events = [
  'resize',
  'scroll',
  'touchstart',
  'touchmove',
  'touchend',
  'pageshow',
  'load',
];

const hardwareAcceleration = { transform: 'translateZ(0)' };

export default class Sticky extends Component {
  placeholder: React.RefObject<unknown>;
  container: React.RefObject<unknown>;
  rafHandle: null;
  constructor(props: any) {
    super(props);
    this.placeholder = React.createRef();
    this.container = React.createRef();
    this.state = {
      isSticky: false,
      style: {},
      placeholderHeight: 0,
    };
    this.rafHandle = null;
    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {
    events.forEach((event) => window.addEventListener(event, this.handleEvent));
  }

  componentWillUnmount() {
    if (this.rafHandle) {
      raf.cancel(this.rafHandle);
      this.rafHandle = null;
    }
    events.forEach((event) =>
      window.removeEventListener(event, this.handleEvent),
    );
  }

  handleEvent() {
    this.rafHandle = raf(() => {
      const { top, height } = this.container.current.getBoundingClientRect();
      // 由于container只包裹着placeholder和吸顶元素，且container的定位属性不会改变
      // 因此container.getBoundingClientRect().top大于0则吸顶元素处于正常文档流
      // 小于0则吸顶元素进行fixed定位，同时placeholder撑开吸顶元素原有的空间
      const { width } = this.placeholder.current.getBoundingClientRect();
      if (top >= 0 && this.state.isSticky) {
        this.setState({
          isSticky: false,
          style: {},
          placeholderHeight: 0,
        });
      } else if (top < -50 && !this.state.isSticky) {
        this.setState({
          isSticky: true,
          style: {
            position: 'fixed',
            top: '0',
            width,
            ...hardwareAcceleration,
          },
          placeholderHeight: height,
        });
      }
    });
  }

  render() {
    const { style, placeholderHeight, isSticky } = this.state;
    return (
      <div ref={this.container}>
        <div style={{ height: placeholderHeight }} ref={this.placeholder} />
        {this.props.content(style, isSticky)}
      </div>
    );
  }
}
